import { render, staticRenderFns } from "./RentACarOrderDetailAncillaries.vue?vue&type=template&id=488478b2&scoped=true"
import script from "./RentACarOrderDetailAncillaries.vue?vue&type=script&lang=js"
export * from "./RentACarOrderDetailAncillaries.vue?vue&type=script&lang=js"
import style0 from "./RentACarOrderDetailAncillaries.vue?vue&type=style&index=0&id=488478b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488478b2",
  null
  
)

export default component.exports